import Payer from '@/services/payer'

const fetch = async (context, id) => {
  return new Promise((resolve, reject) => {
    Payer.paymentNotifications(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const sendMail = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Payer.sendEmail(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetch,
  sendMail
}



// WEBPACK FOOTER //
// ./src/features/payer_payment_notifications/store/actions.js